import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import Modal from "../../molecules/Modal/Modal";
import { MenuWrapper, MenuList, MenuItemWrapper, HamburgerWrapper, MobileMenuContainer, DesktopMenuContainer } from "./Menu.style";
import { Link } from "../../atoms/Link/Link";
import CloseIcon from "../../../assets/icons/CloseIcon";
import MenuIcon from "../../../assets/icons/MenuIcon";
import { Button } from "../../atoms/Button/Button";
export const Menu = ({ items, headerContent, footerContent, isOpen, onToggle, inverse = false }) => {
    const [internalIsOpen, setInternalIsOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const isControlled = isOpen !== undefined;
    const isMenuOpen = isControlled ? isOpen : internalIsOpen;
    const handleToggle = (newState) => {
        if (isControlled) {
            if (onToggle)
                onToggle(newState);
        }
        else {
            setInternalIsOpen(newState);
        }
    };
    const toggleMenu = (e) => {
        if (e)
            e.preventDefault();
        handleToggle(!isMenuOpen);
    };
    const renderMenuContent = () => {
        return (items && items.length > 0 ? (items.map((item, index) => {
            const isActive = location.pathname === item.path;
            return (_jsx(MenuItemWrapper, { children: _jsx(Link, { className: `ps-header-inferior-menu-links${isActive ? ' active' : ''}`, href: item.path, target: item.targetBlank ? "_blank" : "_self", hideIcon: true, onClick: (e) => {
                        if (!item.targetBlank && item.path.startsWith('/')) {
                            e.preventDefault();
                            navigate(item.path);
                        }
                        handleToggle(false);
                    }, inverse: inverse, children: item.name }) }, index));
        })) : null);
    };
    return (_jsxs(MenuWrapper, { "$inverse": inverse, children: [_jsx(HamburgerWrapper, { children: _jsx(Button, { variant: "tertiary", size: "medium", onClick: toggleMenu, iconOnly: true, leftSvgIcon: isMenuOpen ? _jsx(CloseIcon, { width: "24", height: "24" }) : _jsx(MenuIcon, { width: "24", height: "24" }), "aria-label": isMenuOpen ? "Fechar menu" : "Abrir menu", "aria-expanded": isMenuOpen, inverse: inverse }) }), _jsxs(Modal, { open: isMenuOpen, onClose: () => handleToggle(false), fullWidth: true, containerComponent: (props) => _jsx(MobileMenuContainer, Object.assign({}, props, { "$inverse": inverse })), disableAutoFocus: true, children: [headerContent, _jsx(MenuList, { children: renderMenuContent() }), footerContent] }), _jsx(DesktopMenuContainer, { children: _jsx(MenuList, { children: renderMenuContent() }) })] }));
};
//# sourceMappingURL=Menu.js.map